$(".text-desc-main-heading").click(function(){
  $(".text-desc-main-heading").removeClass('active');
  $(this).addClass('active');

  var id = $(this).attr('data_id');

  $(".text-desc-main-desc").removeClass('active');
  $(this).parents(".text-desc-inner-row").find('.text-desc-main-desc[data_id="' + id + '"]').addClass('active');
});


$(document).on("click",".product-card-wrapper .swatch-input__label",function() {
  var element = $(this).prev()
  var id = element.data('variant-id').trim();
  var parent = $(this).parents('.product-card-wrapper');

  parent.find('.swatch-input__input').removeAttr('checked');
  element.attr("checked", true);

  parent.find('.card__media img').addClass('hide');
  parent.find('.card__media img').removeClass('active');
  
  if(parent.find('.card__media img[variant-id="'+id+'"]').length > 0){
    parent.find('.card__media img[variant-id="'+id+'"]').addClass('active');
  }else{
    parent.find('.card__media img:first-child').addClass('active');
  }
});

$(".text-desc-main-heading").click(function(){
  $(this).parent().toggleClass('open');
  $(this).parents(".product-meta-accordion_item").find('.text-desc-main-desc').slideToggle();
});


$(document).on("change",".upcart-upsell-item-variant-selector",function() {
  var id = $(this).val();
  $(this).parents('.cart_recommendation-item-info').find('[name="id"]').val(id);
});
  


// Source - https://stackoverflow.com/q/17605296
// Posted by Mr. Lavalamp, modified by community. See post 'Timeline' for change history
// Retrieved 2026-05-11, License - CC BY-SA 3.0
$(document).on("click", "#CartDrawer-Overlay", function () {
    $('cart-drawer').get(0).close();
    $('body').removeClass('overflow-hidden');
});